import React from 'react';

import { Row, Col } from 'react-bootstrap';
import ReactTable from 'react-table';

import {
    ControlPageBlock, InputField, TextAreaField, SelectorField,
} from '../blocks/edit_blocks';
import Fetcher from '../common/communicate';
import { TAG_TYPES, PROJECT_PREFIX } from '../const';
import { Text2Slug } from '../tools/converters';

export default class TagEditScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: { games: [] },
            not_valid: {},
        };

        this.handleData = this.handleData.bind(this);
        this.titleChange = this.titleChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.sendData = this.sendData.bind(this);
        this.removeData = this.removeData.bind(this);
        this.goToNewPage = this.goToNewPage.bind(this);
        this.goToPreviousPage = this.goToPreviousPage.bind(this);

        if (props.match.params.tagId) {
            this.state.API_ENDPOINT = `tags/${props.match.params.tagId}/`;
        } else {
            this.setState({});
            this.state.API_ENDPOINT = 'tags/';
        }
    }

    handleChange(event) {
        let state = event.currentTarget.value;

        if (event.currentTarget.type === 'checkbox') {
            if (event.currentTarget.checked) {
                state = 1;
            } else {
                state = 0;
            }
        }

        const new_state = this.state;
        new_state.data[event.currentTarget.id] = state;
        this.setState(new_state);
    }

    handleData(data) {
        this.setState({ loading: false, data });
    }

    sendData(event) {
        this.validate();
        const save_type = event.currentTarget.id;

        let request_method = 'PUT';

        if (!this.props.match.params.tagId) {
            request_method = 'POST';
        }

        let callback = this.handleData;

        if (save_type === 'save_button') {
            callback = this.goToPreviousPage;
        }

        if (!this.props.match.params.tagId) {
            callback = this.goToNewPage;
        }

        Fetcher(this.state.API_ENDPOINT, request_method, callback, this.state.data);
    }

    goToNewPage(newData) {
        this.setState({ API_ENDPOINT: `tags/${newData.id}/` });
        this.props.history.push(`${PROJECT_PREFIX}/tags/${newData.id}/edit`);
    }

    goToPreviousPage() {
        this.props.history.push(`${PROJECT_PREFIX}/tags/all`);
    }

    removeData() {
        Fetcher(this.state.API_ENDPOINT, 'DELETE', this.goToPreviousPage);
    }

    componentDidMount() {
        if (this.props.match.params.tagId) {
            Fetcher(this.state.API_ENDPOINT, 'GET', this.handleData);
        } else {
            this.setState({
                loading: false, data: { type: 'mod', games: [] },
            });
        }
    }

    columns = [{
        Header: 'Название',
        accessor: 'name',
        minWidth: 400,
    }];

    titleChange(event) {
        const state = event.currentTarget.value;
        const new_state = this.state;
        new_state.data[event.currentTarget.id] = state;
        new_state.data.slug = Text2Slug(state);
        this.setState(new_state);
    }

    validate() {
        const no_valid_fields = {};
        const req_fields = ['name', 'slug'];

        for (let i = 0; i < Object.keys(req_fields).length; i++) {
            if (!this.state.data[req_fields[i]]) {
                no_valid_fields[req_fields[i]] = true;
            }
        }

        this.setState({ not_valid: Object.assign(this.state.not_valid, no_valid_fields) });
    }

    render() {
        if (this.state.loading) {
            return null;
        }

        return (
            <div>
                <Row>
                    <Col md={12}>
                        <h4>Привязанные игры</h4>
                    </Col>
                </Row>
                <Row>
                    <Col md={5}>
                        <ReactTable
                            defaultPageSize={this.state.data.games.length}
                            showPageSizeOptions={false}
                            showPagination={false}
                            data={this.state.data.games}
                            columns={this.columns}

                        />
                    </Col>
                    <Col md={7}>
                        <Row>
                            <Col md={12}>
                                <InputField
                                    name="name"
                                    label="Название"
                                    value={this.state.data.name}
                                    onChange={this.titleChange}
                                    required
                                    is_not_valid={this.state.not_valid.name || false}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <InputField
                                    name="slug"
                                    label="Slug"
                                    value={this.state.data.slug}
                                    onChange={this.handleChange}
                                    required
                                    is_not_valid={this.state.not_valid.slug || false}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <TextAreaField
                                    name="name_alt"
                                    label="Синонимы"
                                    value={this.state.data.name_alt || ''}
                                    onChange={this.handleChange}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <SelectorField
                                    name="type"
                                    label="Тип"
                                    options={TAG_TYPES}
                                    selected={this.state.data.type}
                                    onChange={this.handleChange}

                                />
                            </Col>
                            <Col md={12}>
                                <ControlPageBlock
                                    name={this.state.data.name}
                                    onSave={this.sendData}
                                    onApply={this.sendData}
                                    onCancel={this.goToPreviousPage}
                                    onRemove={this.removeData}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }
}
